/**
 * The corporate website — the marketing site behind the footer's Disclaimer and Cookies links.
 *
 * Domain only, on purpose: the page paths never change and the language segment is runtime, so
 * consumers compose those. Keeping the constant to the one part a rebrand actually moves means a
 * future domain change touches exactly one value.
 */
export const CORPORATE_SITE_URL = 'https://mobeyond.eu';
